import _mapInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/map";
import * as _ from "../../../util/lodash";
import React from 'react';
import cx from 'classnames';
import moment from 'moment-timezone';
import Layout from "../../core/layout";
import Button from "../../core/button";
import Label from "../../core/label";
import CKImage from "../../core/image";
import Tooltip from "../../core/tooltip";
import EmptyState from "../../core/empty-state";
import { createComponent, PropTypes } from "../../../wayin-react";
import * as FileUtils from "../../core/asset-uploader/file-utils";
import { positions, sizes, widths, textAlignments, font, directions, icons } from "../../../enums";
var AssetList = createComponent({
  displayName: 'AssetView',
  refs: 'inputRef',
  propTypes: {
    onAssetSelected: PropTypes.func.isRequired,
    list: PropTypes.arrayOf(PropTypes.shape({
      name: PropTypes.string,
      assetRef: PropTypes.string,
      thumbnailAssetPath: PropTypes.string,
      height: PropTypes.number,
      width: PropTypes.number,
      fileSize: PropTypes.number,
      modifiedBy: PropTypes.string,
      lastUpdated: PropTypes.string
    })),
    isCompact: PropTypes.bool,
    userTimeZone: PropTypes.shape({
      name: PropTypes.string,
      offset: PropTypes.string
    }),
    isExperienceScope: PropTypes.bool,
    onFileSelected: PropTypes.func.isRequired,
    searchQuery: PropTypes.string
  },
  defaultProps: {
    list: [],
    isCompact: false,
    userTimeZone: {
      name: 'Europe/London',
      offset: '0'
    },
    isExperienceScope: false,
    searchQuery: undefined
  },
  handlers: {
    onSelect: function onSelect(p) {
      return function (e, v) {
        p.onAssetSelected(v.value);
      };
    },
    onNewAssetClick: function onNewAssetClick(p) {
      return function (e) {
        p.onFileSelected(e, !p.isExperienceScope);
      };
    }
  },
  render: function render(props) {
    var list = props.list,
        onSelect = props.onSelect,
        isCompact = props.isCompact,
        userTimeZone = props.userTimeZone,
        onNewAssetClick = props.onNewAssetClick,
        isExperienceScope = props.isExperienceScope,
        searchQuery = props.searchQuery;
    var noPadding = {
      padding: 0
    };
    var emptyStateHeader = searchQuery ? 'There are no matches for your search' : 'There are no items to display';
    var emptyStateByline = searchQuery ? '' : isExperienceScope ? 'You do not have any images loaded into your experience. Hit the button below and start loading!' : 'You currently have no assets in Grow. Hit the button below and start loading!';

    var browseFile = function browseFile() {
      props.refs.inputRef.click();
    };

    return /*#__PURE__*/React.createElement("div", {
      className: "asset-select"
    }, /*#__PURE__*/React.createElement("div", {
      className: "asset-select__header"
    }, /*#__PURE__*/React.createElement(Layout, {
      columnStyles: {
        textAlign: textAlignments.CENTER,
        verticalAlign: positions.verticalAlign.MIDDLE
      }
    }, /*#__PURE__*/React.createElement(Layout.Row, {
      columns: widths.SEVEN
    }, /*#__PURE__*/React.createElement(Layout.Column, {
      columnWidth: widths.TWO,
      textAlign: textAlignments.LEFT
    }, /*#__PURE__*/React.createElement(Label, {
      text: "Title",
      font: {
        emphasis: font.emphasis.CAPS
      },
      size: sizes.X2,
      style: noPadding
    })), /*#__PURE__*/React.createElement(Layout.Column, {
      columnWidth: widths.FOUR
    }), /*#__PURE__*/React.createElement(Layout.Column, {
      columnWidth: widths.TWO
    }, /*#__PURE__*/React.createElement(Label, {
      text: "Size",
      font: {
        emphasis: font.emphasis.CAPS
      },
      size: sizes.X2,
      style: noPadding
    })), /*#__PURE__*/React.createElement(Layout.Column, {
      columnWidth: widths.TWO
    }, /*#__PURE__*/React.createElement(Label, {
      text: "Modified on",
      font: {
        emphasis: font.emphasis.CAPS
      },
      size: sizes.X2,
      style: noPadding
    })), /*#__PURE__*/React.createElement(Layout.Column, {
      columnWidth: widths.FOUR
    }, /*#__PURE__*/React.createElement(Label, {
      text: "Modified by",
      font: {
        emphasis: font.emphasis.CAPS
      },
      size: sizes.X2,
      style: noPadding
    })), /*#__PURE__*/React.createElement(Layout.Column, {
      columnWidth: widths.TWO
    })))), /*#__PURE__*/React.createElement("div", {
      className: cx('asset-select__list', {
        'asset-select__list--modal': isCompact
      })
    }, /*#__PURE__*/React.createElement(Layout, {
      borders: directions.H,
      columnStyles: {
        textAlign: textAlignments.CENTER,
        verticalAlign: positions.verticalAlign.MIDDLE
      }
    }, _mapInstanceProperty(_).call(_, list, function (asset, assetIdx) {
      var gmtTime = moment.tz(asset.lastUpdated, 'GMT'),
          userTime = gmtTime.tz(userTimeZone.name);
      var isPortrait = FileUtils.isAssetPortrait(asset.width, asset.height);
      return /*#__PURE__*/React.createElement(Layout.Row, {
        columns: widths.SEVEN,
        key: 'asset' + assetIdx
      }, /*#__PURE__*/React.createElement(Layout.Column, {
        columnWidth: widths.TWO,
        textAlign: textAlignments.LEFT
      }, /*#__PURE__*/React.createElement("div", {
        className: cx('file-thumbnail-wrapper', {
          'file-thumbnail-wrapper--landscape': !isPortrait,
          'file-thumbnail-wrapper--portrait': isPortrait
        })
      }, /*#__PURE__*/React.createElement(CKImage, {
        src: asset.thumbnailAssetPath + "?rnd=" + asset.lastUpdated
      }))), /*#__PURE__*/React.createElement(Layout.Column, {
        columnWidth: widths.FOUR,
        textAlign: textAlignments.LEFT
      }, /*#__PURE__*/React.createElement(Label, {
        text: asset.name,
        isFluid: true,
        style: noPadding,
        font: {
          weight: font.weights.MEDIUM
        },
        size: sizes.MEDIUM
      })), /*#__PURE__*/React.createElement(Layout.Column, {
        columnWidth: widths.TWO
      }, /*#__PURE__*/React.createElement(Label, {
        text: asset.width ? asset.width + 'x' + asset.height + 'px' : '',
        isFluid: true,
        style: noPadding
      })), /*#__PURE__*/React.createElement(Layout.Column, {
        columnWidth: widths.TWO
      }, /*#__PURE__*/React.createElement(Tooltip, {
        tooltip: userTime.format('MMM DD YYYY, HH:mm a z')
      }, /*#__PURE__*/React.createElement(Label, {
        text: userTime.fromNow(),
        style: noPadding,
        isFluid: true
      }))), /*#__PURE__*/React.createElement(Layout.Column, {
        columnWidth: widths.FOUR
      }, /*#__PURE__*/React.createElement(Label, {
        text: asset.modifiedBy.name,
        style: noPadding,
        isFluid: true
      })), /*#__PURE__*/React.createElement(Layout.Column, {
        columnWidth: widths.TWO
      }, /*#__PURE__*/React.createElement(Button.Primary, {
        text: "Select",
        onClick: onSelect,
        value: asset,
        size: sizes.X1
      })));
    })), !list.length ? [/*#__PURE__*/React.createElement(Layout, {
      style: {
        marginTop: '220px'
      },
      isCentered: true,
      key: "0"
    }, /*#__PURE__*/React.createElement(EmptyState, {
      icon: icons.INFO,
      header: emptyStateHeader,
      byline: emptyStateByline,
      action: !searchQuery ? /*#__PURE__*/React.createElement(Button.Primary, {
        text: "New Asset",
        onClick: browseFile,
        isDisabled: false
      }) : null
    })), !searchQuery ? /*#__PURE__*/React.createElement("input", {
      ref: props.setInputRef,
      type: "file",
      style: {
        display: 'none'
      },
      onChange: onNewAssetClick,
      key: "1"
    }) : null] : null));
  }
});
export default AssetList;
//# sourceMappingURL=asset-list.js.map